import api from './api';
import { stampActivity, refreshSession, stopSessionGuard, clearAuthStorage } from '../utils/sessionGuard';

// 인증 관련 API 서비스
const authService = {
  // 로그인
  async login(credentials) {
    try {
      const response = await api.post('/auth/login', credentials);
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        // userId 저장 추가
        if (response.data.user && response.data.user.id) {
          localStorage.setItem('userId', response.data.user.id);
        }
        /* [2026-09-07] 로그인 시점을 마지막 활동으로 기록하고 만료·무활동 감시를 다시 세운다.
           WHY: 앞선 로그인에서 남은 오래된 활동 시각이 그대로 있으면, 방금 로그인한 회원이
             첫 요청에서 곧바로 무활동으로 판정돼 로그아웃된다. */
        stampActivity(Date.now());
        refreshSession({ stamp: true });
        
        // authStateChanged 이벤트가 useAuth.js에서 발신되므로 중복 authChange 제거
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 회원가입
  async register(userData) {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 로그인 상태 확인
  async checkAuthStatus() {
    try {
      const response = await api.get('/auth/status');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // [게스트 게임종류] 미로그인(게스트)용 공개 게임종류 조회 (도메인 기준 운영사 활성 게임종류).
  //   인증 불요 공개 엔드포인트. base URL 은 api 인스턴스 재사용(하드코딩 없음).
  async getPublicEnabledGameTypes() {
    const response = await api.get('/auth/public-game-types');
    return response.data; // { success, enabledGameTypes: [...] }
  },

  // 로그아웃
  async logout() {
    try {
      // 서버에 로그아웃 요청
      await api.post('/auth/logout');
    } catch (error) {
      console.error('로그아웃 API 요청 실패:', error);
      // 서버 요청 실패해도 로컬 정리는 진행
    } finally {
      /* [2026-09-07] 정상 로그아웃도 만료·강제 로그아웃과 같은 정리 규칙을 쓴다.
         WHY: 종전에는 token·userId 만 지워 잔액·포인트가 남았고, 다음에 그 화면을 연 회원에게
           직전 회원의 값이 잠깐 그려졌다. 활동 기록·만료 감시·게임 표시도 함께 정리한다. */
      stopSessionGuard();
      clearAuthStorage();
      // 웹소켓 연결이 있다면 해제
      if (window.socket) {
        window.socket.disconnect();
      }

      // authStateChanged 이벤트가 useAuth.js에서 발신되므로 중복 authChange 제거
    }
  },

  // 휴대폰 인증번호 발송
  async sendVerificationCode(phone) {
    try {
      const response = await api.post('/auth/send-verification', { phone });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // 인증번호 확인
  async verifyCode(phone, code) {
    try {
      const response = await api.post('/auth/verify-code', { phone, code });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  }
};

export default authService;